import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CobrowseFeatureService {
  private cobrowseInitalValue = false;
  private cobrowseSubject = new BehaviorSubject<boolean>(this.cobrowseInitalValue);
  private cobrowseFeatureObservable = this.cobrowseSubject.asObservable();

  setCobrowseFeatureValue(value: boolean) {
    return this.cobrowseSubject.next(value);
  }

  getCobrowseFeatureValue(): Observable<boolean> {
    return this.cobrowseFeatureObservable;
  }
}
